import { Flex, Skeleton } from '@iheartjane/reefer';

import styles from './imageSkeleton.module.css';

export const ImageSkeleton = () => (
  <Skeleton animate>
    <Flex>
      <Skeleton.Bone className={styles['imageSkeleton']} />
    </Flex>
  </Skeleton>
);
